module.exports = __webpack_public_path__ + "static/media/All.8ef5164f.svg";